import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { buildSymbolDependentRequestHelpers } from 'widgets/streaming/buildSymbolDependentRequestHelpers';
import { WidgetConfigWithSymbol } from 'widgets/WidgetSettingsEditing/WidgetSettingsSymbolEditor';

export interface GetSymbolInfoRequestPayload {
    symbol: string;
    symbology: string;
}

function toSymbolInfoStreamRequest(
    symbol: string | undefined,
    symbology: SymbologyValues
) {
    return symbol
        ? {
              symbol,
              symbology,
          }
        : undefined;
}

function toRequestUid(symbol: string, _config: unknown): string {
    return `symbolInfo-${symbol}`;
}

const {
    getWidgetStreamRequestInfo,
    getStreamRequestInfosForSymbols,
    createWidgetRequestUid,
} = buildSymbolDependentRequestHelpers<
    GetSymbolInfoRequestPayload,
    WidgetConfigWithSymbol
>(
    toRequestUid,
    (r) => toRequestUid(r.symbol, {}),
    (symbol, symbology, _config) =>
        toSymbolInfoStreamRequest(symbol, symbology)!,
    {}
);

export {
    getWidgetStreamRequestInfo as getSymbolInfoStreamRequestInfo,
    getStreamRequestInfosForSymbols as getSymbolInfoStreamRequestInfosForSymbols,
    createWidgetRequestUid as createSymbolInfoWidgetRequestUid,
    toRequestUid as createSymbolInfoRequestUid,
};
